import * as React from 'react';
import { Field, reduxForm, change } from 'redux-form';
//import transferForm from '../forms/transferForm';
import styles from './deFormStyles';
import { TouchableOpacity, Platform } from 'react-native';
import { Container, Header, InputGroup, Content, Text, Label, Item, Input, Icon, Toast, Form, Spinner, View, Left, Right, Body, Button, Title } from 'native-base';

import * as _ from 'lodash';

import FormFooter from '../components/formFooter';
import { textInput, moneyInput, renderPicker, renderDateField, renderSlider, percentInput, displayInput } from './renderedComponents';
import Picker from '../components/picker';

function syncValidate(values, props) {
	//runs while field changing
	let errors = {};

	if (!values.description) errors.description = 'Required';
	if (parseFloat(values.paid) > 0 && values.account_id == 0) errors.account_id = 'Please select an account';

	return errors;
}

function asyncValidate(values, dispatch, props, field) {
	return new Promise((resolve, reject) => {
		//runs on BLUR for amount. So first update values
		var value = Number(values[field]);
		var Dispval = parseFloat(isNaN(value) ? 0 : value).toFixed(2);
		__DEV__ && console.log('changing ', field, Dispval);
		dispatch(change('assetForm', field, Dispval));

		var vatReg = props.vatReg;

		var net = parseFloat(values.net);
		var vat = parseFloat(values.vat);
		var gross = parseFloat(values.gross);

		if ((field == 'net' || field == 'gross') && !!net && !!gross) {
			//set vat
			__DEV__ && console.log('changing ', 'notvat', Math.max(0, gross - net).toFixed(2));
			dispatch(change('assetForm', 'notvat', Math.max(0, gross - net).toFixed(2)));
		}

		resolve();
	});
}

class assetForm extends React.Component {
	constructor(props) {
		super(props);

		this.initialState = {};
		this.state = this.initialState;
		//console.log('assetForm - ', this.props);
	}

	componentDidMount() {}

	componentWillReceiveProps(nextProps) {}

	_changeFormVal(field, val) {
		__DEV__ && console.log('setting ', field, val);
		this.props.dispatch(change('assetForm', field, val));
	}

	render() {
		const { handleSubmit, pristine, reset, submitting, transType, isNew } = this.props;
		this.formRefs = [];

		return (
			<View style={{ flex: 1 }}>
				<Content padder keyboardShouldPersistTaps={'handled'}>
					<Form onSubmit={this.props.handleSubmit}>
						<Field name="name" label="Name" component={textInput} />
						<Field name="description" label="Description" component={textInput} />
						<Field name="assetcategory_id" disabled={!isNew} label="Asset Type" component={renderPicker} style={{ flex: 1 }} iosHeader="Select asset type" mode="dropdown">
							{this.props.assetCategories.map((item, i) => (
								<Picker.Item key={i} label={item.name} value={item.id} />
							))}
						</Field>
						<Field name="lastPURate" label="Personal Use" component={renderSlider} />
						<Field name="purchaseDate" label="Purchase Date" component={renderDateField} />
						<Field name="net" label="Amount" component={moneyInput} forwardRef ref={c => this.formRefs.push(c)} />
						{!!this.props.vatReg && <Field name="notvat" label="VAT" component={moneyInput} disabled forwardRef ref={c => this.formRefs.push(c)} />}
						{!!this.props.vatReg && <Field name="gross" label="Gross" component={moneyInput} forwardRef ref={c => this.formRefs.push(c)} />}

						<Field name="account_id" label={'Purchase account'} component={renderPicker} style={{ flex: 1 }} iosHeader="Select account" mode="dropdown">
							{this.props.accounts
								.filter(item => {
									return item.accountType < 2;
								})
								.map((item, i) => (
									<Picker.Item key={i} label={item.nickName} value={item.id} />
								))}
						</Field>
					</Form>
				</Content>

				<FormFooter formRefs={this.formRefs} updateVal={this._changeFormVal.bind(this)} />
			</View>
		);
	}
}

export default reduxForm({
	form: 'assetForm',
	validate: syncValidate,
	asyncValidate,
	asyncBlurFields: ['net', 'gross']
})(assetForm);
